import React from "react";
import { Link, withRouter } from "react-router-dom";
import { InputElement } from "../../shared/FormElements";
import { SiteConstants } from "../../../constants/constant";

const SignupForm = props => {
  const sendApiHit = () => {
    props.sucessHandler(props.formName);
  };
  const handleEnterKey = event => {
    const eventCode = event.which || event.keyCode;
    if (eventCode === SiteConstants.ENTER_KEY_EVENT_CODE) {
      sendApiHit();
    }
  };
  const signUpStructure = props.form.map((value, index) => (
    <InputElement
      name={value.id}
      type={value.config.type}
      class={
        value.config.class ? value.config.class : "mb-3 col-12 form-group mt-20"
      }
      label={value.config.label}
      required={value.config.validation.require}
      value={value.config.value}
      validationTick={
        value.config.validationTick && value.config.validationTick
      }
      blurred={value.config.blurred && value.config.blurred}
      onChangeHandler={props.onChangeHandler}
      formName={props.formName}
      onBlurHandler={props.onBlurHandler}
      errorMsg={value.config.errorMsg}
      valid={value.config.valid}
      maxLength={value.config.maxLength}
      placeholder={value.config.placeholder ? value.config.placeholder : ""}
      belowPlaceholder={
        value.config.belowPlaceholder ? value.config.belowPlaceholder : ""
      }
    />
  ));
  return (
    <div className="signUpForm">
      <div className="text-center">
        {props.message && <p className="error">{props.message}</p>}
        <h3>Sign up</h3>
        <p className="subHeading">Create an ausbiz account with your email</p>
      </div>
      <div className="mt-30">
        <div className="row">{signUpStructure}</div>
      </div>
      <div className="mt50">
        <button
          type="button"
          className={props.btnDisabled ? "btn continue" : "btn continue active"}
          disabled={props.btnDisabled ? "disabled" : ""}
          onClick={() => sendApiHit()}
          onKeyPress={event => handleEnterKey(event)}
        >
          Create account
        </button>
        <div className="signup_new_Terms">By clicking ‘Create account’, you agree to ausbiz’s
        <a href="https://company.ausbiz.com.au/privacy-policy" target="_blank">
            &nbsp;Privacy Policy&nbsp;
          </a>
           and
           <a href="https://company.ausbiz.com.au/terms-of-service" target="_blank">
            &nbsp;Terms of Use&nbsp;
          </a>
           including receiving email updates and offers from ausbiz. You may unsubscribe at any time.</div>
        <p className="text-center">
          Already have an account?
          <a href="javascript:void(null);" onClick={() => props.changeFormHandler('signin')} >&nbsp;&nbsp;Sign in</a>
        </p>
      </div>
    </div>
  );
};

export default withRouter(SignupForm);
